import { render, staticRenderFns } from "./CustomStateEditor.vue?vue&type=template&id=127abef4&scoped=true&"
import script from "./CustomStateEditor.vue?vue&type=script&lang=js&"
export * from "./CustomStateEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomStateEditor.vue?vue&type=style&index=0&id=127abef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127abef4",
  null
  
)

export default component.exports